// React
import React, { useState } from "react";

// @mui material components
import {
  Grid,
  Card,
  Fab,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  Breadcrumbs,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { ArrowBack } from "@mui/icons-material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Data
import QuestionsTableData from "layouts/lessons/quizzes/questions/data/questionsTableData";

// Dialog add
import ModalAdd from "layouts/lessons/quizzes/questions/components/modalAdd";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="left" ref={ref} {...props} />
));

function Questions({ lessonId, quiz, finished, toLesson }) {
  const [add, setAdd] = useState(false);

  return (
    <Dialog fullScreen open TransitionComponent={Transition}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={finished} aria-label="close">
            <ArrowBack />
          </IconButton>
          <MDTypography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <MDTypography
                sx={{ cursor: "pointer" }}
                onClick={toLesson}
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Leçon
              </MDTypography>
              <MDTypography
                sx={{ cursor: "pointer" }}
                onClick={finished}
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Quiz
              </MDTypography>
              <MDTypography variant="caption" color="text" fontWeight="medium">
                {quiz.title}
              </MDTypography>
            </Breadcrumbs>
          </MDTypography>
        </Toolbar>
      </AppBar>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                sx={{ display: "flex" }}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography sx={{ flexGrow: 1 }} variant="h6" color="white">
                  Questions
                </MDTypography>
                <Fab
                  color="inherit"
                  aria-label="add"
                  size="small"
                  sx={{ float: "right" }}
                  onClick={() => setAdd(true)}
                >
                  <AddIcon />
                </Fab>
              </MDBox>
              {add && (
                <ModalAdd lessonId={lessonId} quizId={quiz.id} finished={() => setAdd(false)} />
              )}
              <MDBox pt={3} sx={{ overflowX: "hidden" }}>
                <QuestionsTableData
                  lessonId={lessonId}
                  quizId={quiz.id}
                  toQuiz={finished}
                  toLesson={toLesson}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </Dialog>
  );
}

Questions.propTypes = {
  lessonId: PropTypes.number.isRequired,
  quiz: PropTypes.oneOfType([PropTypes.object]).isRequired,
  finished: PropTypes.func.isRequired,
  toLesson: PropTypes.func.isRequired,
};

export default Questions;
